import { render } from "./LockableBox.vue?vue&type=template&id=cb2b069a&scoped=true&lang=pug"
import script from "./LockableBox.vue?vue&type=script&setup=true&lang=js"
export * from "./LockableBox.vue?vue&type=script&setup=true&lang=js"

import "./LockableBox.vue?vue&type=style&index=0&id=cb2b069a&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2b069a"]])

export default __exports__